import { InputAdornment, InputAdornmentProps } from '@mui/material';

export function BaseInputAdornment({ children, ...otherProps }: InputAdornmentProps) {
  return <InputAdornment {...otherProps}>{children}</InputAdornment>;
}
